export enum ToggleVariant {
	PRIMARY = 'primary',
	COMPACT = 'compact',
}